export default {
	name: 'PasswordValidator',
	props: {
		password: {
			value: Object
		}
	},
	data() {
		return {
			lowercaseRegex: /[a-z]/,
			uppercaseRegex: /[A-Z]/,
			digitOrSpecialRegex: /[\d !"#$%&'()*+,-.\/:;<=>?@\[\\\]^_`{|}~]/,
			minLength: 8
		};
	},
	computed: {
		containsLowercase() {
			return this.lowercaseRegex.test(this.password);
		},
		containsUppercase() {
			return this.uppercaseRegex.test(this.password);
		},
		containsDigitOrSpecial() {
			return this.digitOrSpecialRegex.test(this.password);
		},
		enoughLong() {
			return this.password.length >= this.minLength;
		}
	},
	methods: {
		isValid() {
			return this.containsLowercase && this.containsUppercase && this.containsDigitOrSpecial && this.enoughLong;
		}
	}

};



// WEBPACK FOOTER //
// ./app/components/password-validator/script.js